import React, { useEffect, useContext, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import Service from "../services/service";
import * as actions from "../actions/actions";
import { showCaptcha, config, resolveNotificationMessage } from '../helpers/constants';
import { Box, Paper, Typography, Button } from "@material-ui/core";
import FullScreenPage from "./FullScreenPage";
import LicenseQuotePanel from './LicenseQuotePanel';
import DividerLabel from "./DividerLabel";
import { ReactComponent as CheckedIcon } from '../assets/icons/checked.svg';
import LoadingScreen from "./LoadingScreen";
import LogoSquare from '../assets/plagaware-logo-square-50x50.png';



const useStyles = makeStyles((theme) => ({
  paper: {
    width: 850,
    minHeight: 500,
    position: "relative",
    boxShadow: "0px 0px 5px 5px rgba(0, 0, 0, 0.25)",
    "&:hover": {
      boxShadow: "0px 0px 7px 7px rgba(0, 0, 0, 0.4)",
      transition: "box-shadow 0.3s ease-in-out",
    }
  }
}));

export default function Quote(props) {
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles();
  const [clientIp, setClientIp] = useState(null);

  const isBlocked = state.app.maintenanceReason === 'blocked';
  const title = isBlocked ? (s.accessBlocked?.title || 'Access Blocked') : s.maintenance.title;
  const description = isBlocked ? (s.accessBlocked?.description || 'Access to PlagAware has been prevented by data protection measures. Please reach out to PlagAware support.') : s.maintenance.description;
  const footer = isBlocked ? (s.accessBlocked?.contact || 'support@plagaware.com') : s.maintenance.thanks;

  useEffect(() => {
    if (!isBlocked) return;
    fetch('https://api.ipify.org?format=json')
      .then(res => res.json())
      .then(data => { if (data && data.ip) setClientIp(data.ip); })
      .catch(() => {});
  }, [isBlocked]);

  return (
    <FullScreenPage>
      <Paper elevation={5} className={classes.paper}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", padding: 60 }}>
          <img src={LogoSquare} alt="logo" style={{ margin: 16 }} />
          <Box mt={4} />
          <Typography paragraph variant="h6">{title}</Typography>
          <Typography align="center" color="primary">{description}</Typography>
          {isBlocked && clientIp && (
            <>
              <Box mt={2} />
              <Typography align="center" variant="body2">{(s.accessBlocked?.yourIp || 'Your IP address') + ': ' + clientIp}</Typography>
            </>
          )}
          <Box mt={2} />
          <Typography align="center" variant="body2" color="secondary">{footer}</Typography>
        </div>
      </Paper>
    </FullScreenPage>
  )

}
